import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    infoIcon: {
      color: colors.blue700,
      fontSize: "16px",
      display: "flex",
      cursor: "auto"
    }
  }) as CSSObject;
